import { Box, styled } from "@mui/material";

export const NoReleasesContainer = styled(Box)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.palette.customColor.midgroundColor,
  borderRadius: theme.border.radius.md,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  padding: theme.spacing(7, 2),

  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(7, 4),
  },
}));
